import * as React from 'react';
import style      from './Loader.scss';
import classnames from "classnames";

type Props = {
  size?: number,
  absolute?: boolean
};

const Loader = (props: Props) => {
  const { size, absolute } = props;
  let containerStyle = undefined;
  if (size) containerStyle = { '--loader-size': `${size}px` } as React.CSSProperties;
  return (
    <div className={classnames(style.container, absolute && style.absolute)} style={containerStyle} />
  );
};

export default Loader;
